import { render, staticRenderFns } from "./NewChatContactItem.vue?vue&type=template&id=6e50078e"
import script from "./NewChatContactItem.vue?vue&type=script&lang=js"
export * from "./NewChatContactItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports